const convertHexToRgb = (hex: string) => {
	const RADIX = 16;
	const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

	const HEX = hex.replace(shorthandRegex, (m, r, g, b) => r + r + g + g + b + b);
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(HEX);

	return result === null
		? null
		: ({
				r: parseInt(result[1], RADIX),
				g: parseInt(result[2], RADIX),
				b: parseInt(result[3], RADIX)
			} as const);
};

export const convertHexToRgbA = (hex: string, alpha: number) => {
	const color = convertHexToRgb(hex);
	return color === null ? hex : `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
};

type LinearGradientDirection = 'to bottom';
export const createLinearGradient = (colors: string, direction: LinearGradientDirection = 'to bottom') => {
	return `linear-gradient(${direction}, ${colors})`;
};
